import { motion } from 'motion/react'

import { AnimatedController, DeepinsightSymbolAnimated } from '~/astra'
import { LinkButton } from '~/components/LinkButton'
import env from '~/env'

function getLoginUrl() {
    const url = new URL(env.VITE_API_BASE_URL + '/oauth/login')
    url.searchParams.set('redirect_url', window.location.href)
    url.searchParams.set('oauth_client', env.VITE_API_OAUTH_CLIENT)

    return url.toString()
}

export const LoginSection = () => {
    const useReducedMotion = env.VITE_NO_UNSTABLE_EFFECTS
    return (
        <AnimatedController>
            <motion.div
                initial={useReducedMotion ? undefined : { opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 0.8, delay: 0.5 } }}
                className="flex h-full w-full flex-col items-center justify-center gap-12 rounded-[3.75rem] border border-[#ebebeb] bg-[#ebebeb]/30 px-8 shadow-glass backdrop-blur-md md:gap-24"
                data-test="auth-page"
            >
                <DeepinsightSymbolAnimated className="ml-[-1.5rem] h-[86px]" duration={4} delay={0} reducedMotion={useReducedMotion} />

                <h1 className="auth-hero-title select-none text-center">
                    Velkommen til <br />
                    Deepinsight Hero
                </h1>
                <LinkButton
                    data-test="login-button"
                    href={getLoginUrl()}
                    className="flex w-full max-w-[476px] justify-center bg-[#061139] font-semibold hover:bg-[#061139]/75"
                >
                    Logg inn
                </LinkButton>
            </motion.div>
        </AnimatedController>
    )
}
